import { render, staticRenderFns } from "./upstreamInvoicingDetail.vue?vue&type=template&id=45b04dcb&scoped=true"
import script from "./upstreamInvoicingDetail.vue?vue&type=script&lang=js"
export * from "./upstreamInvoicingDetail.vue?vue&type=script&lang=js"
import style0 from "./upstreamInvoicingDetail.vue?vue&type=style&index=0&id=45b04dcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b04dcb",
  null
  
)

export default component.exports